export type ContactOfferKey = "general" | "website-project" | "website-care" | "systems-project" | "data-project" | "lead-flow-diagnostic" | "lead-flow-watch" | "reactivate" | "recover" | "managed-sites" | "site-rescue" | "monitor";

export const contactOffers = {
  "website-project": {
    interest: "Website project",
    source: "website_project",
    eyebrow: "Discuss a website project",
    heading: "What should your website do better?",
    placeholder: "For example: we need to migrate our site without losing important URLs or search traffic, and make sure forms reach the right person.",
    submitLabel: "Discuss a Project",
  },
  "website-care": {
    interest: "Website care",
    source: "website_care",
    eyebrow: "Discuss monthly website care",
    heading: "What should stay healthy after launch?",
    placeholder: "For example: we want someone to check our key pages and form delivery each month, summarize issues, and handle a small allowance of fixes.",
    submitLabel: "Discuss Monthly Care",
  },
  "systems-project": {
    interest: "Business process project",
    source: "systems_project",
    eyebrow: "Discuss a process project",
    heading: "Where does the business process break down?",
    placeholder: "For example: inquiries arrive, but assignment and CRM updates are manual and we cannot see what gets missed.",
    submitLabel: "Discuss a Project",
  },
  "data-project": {
    interest: "Data and reporting project",
    source: "data_project",
    eyebrow: "Discuss a data project",
    heading: "Which decision needs clearer data?",
    placeholder: "For example: we have website and CRM data, but cannot reliably connect source, status, and outcome in one report.",
    submitLabel: "Discuss a Project",
  },
  general: {
    interest: "Project inquiry",
    source: "project_inquiry",
    eyebrow: "Discuss a project",
    heading: "What would you like to make work better?",
    placeholder: "Tell us about the website, workflow, or reporting problem and what a useful outcome would look like.",
    submitLabel: "Discuss a Project",
  },
  "lead-flow-diagnostic": {
    interest: "Lead Flow Diagnostic",
    source: "lead_flow_diagnostic",
    eyebrow: "Request a Lead Flow Diagnostic",
    heading: "Where do leads arrive, stall, or disappear before revenue is recorded?",
    placeholder:
      "For example: leads come in from forms, calls, and booking requests, but routing is inconsistent and nobody trusts the CRM status or source tracking.",
    submitLabel: "Request a Lead Flow Diagnostic",
  },
  "lead-flow-watch": {
    interest: "Lead Flow Watch pilot",
    source: "lead_flow_watch_pilot",
    eyebrow: "Lead Flow Watch pilot",
    heading: "Which lead path should stop failing quietly?",
    placeholder:
      "For example: website inquiries should reach our CRM and an assigned owner, but we cannot tell when delivery or follow-up stalls.",
    submitLabel: "Ask About a Watch Pilot",
  },
  reactivate: {
    interest: "AAI Reactivate - $2,250 fixed-scope sprint",
    source: "reactivate_offer",
    eyebrow: "AAI Reactivate sprint",
    heading: "Which approved customer or estimate list should start producing conversations again?",
    placeholder:
      "For example: we have unsold replacement estimates from the last 90 days, with consent records and room on the schedule.",
    submitLabel: "Ask About the $2,250 Sprint",
  },
  recover: {
    interest: "AAI Recover - 30-day paid pilot",
    source: "recover_offer",
    eyebrow: "AAI Recover paid pilot",
    heading: "Where are service inquiries or estimates getting stuck?",
    placeholder:
      "For example: missed calls wait until the end of the day, and estimates rarely receive a second follow-up.",
    submitLabel: "Ask About the $750 Pilot",
  },
  "managed-sites": {
    interest: "Websites, migrations, and technical rescue review",
    source: "websites_rescue_offer",
    eyebrow: "Websites, migrations, and technical rescue",
    heading: "Does the customer-facing entry point make it easy for the right lead to arrive and reach the next owner?",
    placeholder:
      "For example: our site is outdated, form routing is unreliable, and we need a bounded rebuild without losing the details that matter.",
    submitLabel: "Request a Systems Review",
  },
  "site-rescue": {
    interest: "Website migration or technical rescue review",
    source: "site_rescue_offer",
    eyebrow: "Website migration and technical rescue",
    heading: "What needs to move, repair, or get unstuck without breaking the lead path?",
    placeholder:
      "For example: we need to rebuild a proprietary site in WordPress while preserving URLs, metadata, forms, internal links, and search visibility.",
    submitLabel: "Request a Systems Review",
  },
  monitor: {
    interest: "AAI Monitor demo",
    source: "monitor_demo",
    eyebrow: "AAI Monitor demo",
    heading: "Which lead path needs a reliable delivery check?",
    placeholder:
      "For example: website forms should reach two inboxes and the CRM, but nobody knows when a delivery step fails.",
    submitLabel: "Request a Monitor Demo",
  },
} as const;
